// eslint-disable-next-line import/no-named-as-default
import LeftNav from './LeftNav';

export default LeftNav;
